/*
* @Author: tengmaoqing
* @Date:   2018-06-08 10:38:51
* @Last Modified by:   tengmaoqing
* @Last Modified time: 2018-06-08 18:26:18
*/
import Router from 'vue-router';
import Vue from 'vue';

/**
 * 透传参数，以及默认配置。
 */
class $Router extends Router {
  constructor (params) {
    const defaultOptions = {
      mode: 'history',
      scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
          return savedPosition;
        } else {
          return { x: 0, y: 0 };
        }
      }
    };

    super(Object.assign(defaultOptions, params));
    this.keepQuerys = params.keepQuerys || ['pid'];
    this.beforeEach((to, from, next) => {
      const fQuery = from.query;
      let { query, params, path } = to;
      let needPaddingFlag = false;
      this.keepQuerys.forEach(key => {
        if (!query[key] && fQuery[key]) {
          query[key] = fQuery[key];
          needPaddingFlag = true;
        }
      });
      if (needPaddingFlag) {
        next({ query, params, path });
        return;
      }
      next();
    });
  }

  resolve (to, location, append) {
    const next = typeof to === 'string' ? { path: to } : to;
    next.query = next.query || {};
    this.keepQuerys.forEach(key => {
      if (!next.query[key] && location.query[key]) {
        next.query[key] = location && location.query[key];
      }
    });
    const ret = super.resolve(next, location, append);
    return ret;
  };
};

Vue.use(Router);

export default $Router;



// WEBPACK FOOTER //
// ./src/system/init/init-router.js